import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  datePicker: {
    width: '100%',
    '& > div': {
      padding: 0,
    },
  },
  datePickerInput: {
    padding: theme.spacing(0.7, 0),
    color: theme.palette.text.secondary,
    fontSize: '12px',
    fontFamily: 'Poppins',
    fontWeight: 550,
    letterSpacing: '0.8px',
  },
  datePickerInputAdornment: {
    margin: 0,
  },
  datePickerLabel: {
    width: '100%',
    color: theme.palette.text.secondary,
    fontSize: '12px',
    fontFamily: 'Poppins',
    fontWeight: 550,
    letterSpacing: '0.8px',
    '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
      transform: 'translate(14px, 9px) scale(1)',
    },
  },
  datePickerButton: {
    margin: 0,
    padding: theme.spacing(0.25),
  },
  datePickerIcon: {
    fill: theme.palette.text.secondary,
    fontSize: '1rem',
  },
  datePickerDay: {
    fontStyle: 'normal',
  },
  dateInputContainer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '6px',
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '2px',
    paddingBottom: '2px',
    display: 'flex',
    justifyContent: 'space-between',
    maxHeight: '35px',
    alignItems: 'center',
    cursor: 'pointer',
  },
  readOnlyDateContainer: {
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '2px',
    paddingBottom: '2px',
    display: 'flex',
    height: '35px',
    alignItems: 'center',
  },
});
